import { createContext, useState } from "react";
import { configureAuthSession } from "../api/axios";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [credits, setCredits] = useState(0);
  const [avatarUploaded, setAvatarUploaded] = useState(false);
  const [checking, setChecking] = useState([])
  // Respect stored persist=false instead of defaulting to true via ||
  const storedPersist = localStorage.getItem("persist");
  const [persist, setPersist] = useState(
    storedPersist !== null ? JSON.parse(storedPersist) : true
  );
  const [notifLength, setNotifLength] = useState(0);

  configureAuthSession(auth?.accessToken, setAuth);

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist, credits, setCredits, checking, setChecking, avatarUploaded, setAvatarUploaded, notifLength, setNotifLength }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;
